/* jshint -W040 */
/**
 * Adobe DTM Service
 * @namespace Factories
 */
(function () {
  'use strict';
  angular
    .module('dtmService.module')
    .factory('dtmService', dtmService);
  dtmService.$inject = ['$window', '$timeout'];

  /**
   * @namespace dtmService
   * @description Angular Service implementation for direct calls, http://jimalytics.com/wp-content/uploads/2014/06/Satellite-Cheat-Sheet.pdf
   * @memberof Factories
   */
  function dtmService($window, $timeout) {
    /** @type {Object} */
    var _this = this;
    
    /**
     * @member {Boolean}
     * @description Used to disable the service
     */
    this.enabled = true;

    /**
     * @member {Object}
     * @description Alias to _satellite
     */
    this.dtm = $window._satellite;

    /**
     * @member {Boolean}
     * @description Alias to _debug, for enabling console logs
     */
    this.debug = $window._debug || true;

    /**
     * @member {Boolean}
     * @description Used to check availability of _satellite
     */
    this.isSatelliteExist = (_this.dtm && typeof this.dtm.track === 'function') || false;
    
    /**
     * @type {Object}
     * @description Default values
     */
    var defaults =
    {
      'cat': 'actv',
      'project': 'myfido',
      'transaction': 'unknown',
      'action': {
        'start': 'started',
        'complete': 'completed',
        'exception': 'error'
      },

      'key': {
        'exception': 'error'
      }

    };

    /**
     * @function
     * @description Alias to _satellite.getVar()
     * @param {String} key - Key to get
     * @return {String} Value of Key
     * @memberof Factories.dtmService
     */
    this.getVar = function (key) {
      try{
          if (!_this.isSatelliteExist) {
              return '';
          }
           return _this.dtm.getVar(key);
      }
      //return _this.dtm.getVar(key);
      catch (error) {
          console.log(error);
      }
    };

    /**
     * @function
     * @description Alias to _satellite.setVar()
     * @param {String} key - Key to set to
     * @param {String} value - Value to set
     * @return {Object} Fluent interface, this object
     * @memberof Factories.dtmService
     */
    this.setVar = function (key, value) {
      try {
            if (!_this.isSatelliteExist) {
                return '';
            }
          _this.dtm.setVar(key, value);
         // return _this;
      }
      catch (error) {
          console.log(error);
      }
    };

    /**
     * @function
     * @description Track a "start" action
     * @param {String} transaction - Transaction name to use
     * @param {String} cat - Category name to use, usually "actv" or "pasv"
     * @param {String} action - action name to use
     * @return {Object} Fluent interface, this object
     * @memberof Factories.dtmService
     */
    this.start = function (transaction, cat, action) {
      _this.track(transaction, cat || defaults.cat, action || defaults.action.start);
      return _this;
    };

    /**
     * @function
     * @description Track a "complete" action
     * @param {String} transaction - Transaction name to use
     * @param {String} cat - Category name to use, usually "actv" or "pasv"
     * @return {Object} Fluent interface, this object
     * @memberof Factories.dtmService
     */
    this.complete = function (transaction, cat) {
      _this.track(transaction, cat || defaults.cat, defaults.action.complete);
      return _this;
    };

    /**
     * @function
     * @description Track an "error" action
     * @param {String} transaction - Transaction name to use
     * @param {String} message - Error message to use
     * @param {String} cat - Category name to use, usually "actv" or "pasv"
     * @return {Object} Fluent interface, this object
     * @memberof Factories.dtmService
     */
    this.exception = function (transaction, message, cat) {
      if (message !== null && message !== undefined && message !== '') {
        if (_this.debug) {
          console.log(message);
        }
        _this.setVar(defaults.key.exception, message);
        _this.track(transaction, cat || defaults.cat, defaults.action.exception);
      }
      return _this;
    };

    /**
     * @function
     * @description Track a Form Field Validation "error" action
     * @param {String} transaction - Transaction name to use
     * @param {Object} $element - jQuery $element to get the message form
     * @param {String} cat - Category name to use, usually "actv" or "pasv"
     * @return {Object} Fluent interface, this object
     * @memberof Factories.dtmService
     */
    this.exceptionFormField = function (transaction, $element, cat) {
      var callbak = function () {
        var message = $element.parent().text().trim();
        _this.exception(transaction, message, cat || defaults.cat);
      };

      $window.setTimeout(callbak, 500);
      return _this;
    };
    /**
     * @function
     * @description Track a Form Field Validation "error" action with prefix for error message
     * @param {String} transaction - Transaction name to use
     * @param {Object} $element - jQuery $element to get the message form
     * @param {String} errorPrefix - this value will be prefixed to the error message.
     *                 typical usage, type of error, usually "CS" (client side error) or "SS" (server side error)
     * @param {String} cat - Category name to use, usually "actv" or "pasv"
     * @return {Object} Fluent interface, this object
     * @memberof Factories.dtmService
     */
    this.exceptionFormFieldWithPrefix = function (transaction, $element, errorPrefix, cat ) {
      var callbak = function () {
        var message = $element.parent().text().trim();
        _this.exception(transaction, errorPrefix + '|' + message, cat || defaults.cat);
      };

      $window.setTimeout(callbak, 500);
      return _this;
    };

    /**
     * @function
     * @description Track a "no action"
     * @param {String} transaction - Transaction name to use
     * @param {String} cat - Category name to use, usually "actv" or "pasv"
     * @return {Object} Fluent interface, this object
     * @memberof Factories.dtmService
     */
    this.noAction = function (transaction, cat) {
      _this.track(transaction, cat || defaults.cat);
      return _this;
    };

    /**
     * @function
     * @description Track an action
     * @param {String} transaction - Transaction name to use
     * @param {String} cat - Category name to use, usually "actv" or "pasv"
     * @param {String} action - Action name to use
     * @param {String} project - project name to use
     * @return {Object} Fluent interface, this object
     * @memberof Factories.dtmService
     */
    this.track = function (transaction, cat, action, project) {
      try {
            if (!_this.isSatelliteExist) {
                return;
            }

            var value =
              [
                cat,
                project || defaults.project,
                transaction
              ];

            if (action) {
              value.push(action);
            }
            value = value.join('-');

            if (_this.debug) {
              console.log(value);
            }
            _this.dtm.track(value);
           // return _this;
         }

       catch (error) {
           console.log(error);
       }
     };

    /**
     * @function
     * @description Track an action
     * @param {String} method - Method name to use
     * @return {Object} Fluent interface, this object
     * @memberof Factories.dtmService
     */
    this.direct = function (method) {
      try{
          if (!_this.isSatelliteExist) {
              return;
          }

          _this.dtm.track(method);
          if (_this.debug) {
            console.log(method);
          }
          //return _this;
      }
      catch (error) {
          console.log(error);
      }
      /*_this.dtm.track(method);
      if (_this.debug) {
        console.log(method);
      }
      return _this;*/
    };

    this.fireDtmExceptions = function (ruleName, errorMessages, errorSource) {
      $timeout(function () {
        angular.forEach(errorMessages, function (errorMessage) {
          if (errorSource && errorSource.length > 0) {
            errorMessage = errorSource + '|' + errorMessage;
          }

          _this.exception(ruleName, errorMessage);
        });
      });
    };

    return _this;

  }

})();
